module.exports = __webpack_public_path__ + "media/images/game_icon/en/AB1023-15bf33332a9a2931554ed4a662b68397.png";